var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{staticClass:"anBtn",attrs:{"type":_vm.type,"size":_vm.size,"color":_vm.color,"plain":_vm.plain,"square":_vm.square,"round":_vm.round,"disabled":_vm.disabled,"loading":_vm.loading,"hairline":"","native-type":"button"},on:{"click":_vm.sendcode}},[_vm._v(" "+_vm._s(_vm.disabled ? `${_vm.time}S` : '发送验证码')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }